import React, {Component} from 'react';
import {isEmpty} from 'lodash';
import {connect} from 'react-redux';
import {Card, Button} from 'semantic-ui-react';
import {parseDatesFromProcessedWarranty, validateErrorsWarranty,
  getTotalColumnPart, getTotalColumn} from '../../utils';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {enterKeyCode, tabKeyCode} from '../../../common/constants/keyCodes';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import {convertDateToSpecificFormat} from '../../../common/util/date';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Loader from '../../../common/components/loader';
import WarrantyAdminForm from '../form';

const initialState = {
  'type': 'VE',
  'numTwcDealer': '',
  'numFac': '',
  'orderRepairId': '',
  'repairDate': null,
  'chassis': '',
  'km': '',
  'salesDate': null,
  'historicSalesDate': null,
  'condition': '',
  'cause': '',
  'repair': '',
  'task1': '',
  'task2': '',
  'observationTDE': '',
  'observationDealer': '',
  'principalPart': '',
  'principalPartDescription': '',
  'totalTwc': 0.0,
  // dependes of the type
  // AC
  'previousDate': null,
  'previousKm': '',
  // Service Parts
  'numPreviousOrder': '',
  // Sales Parts
  'previousNumFac': '',
  'numFacActual': '',
  'actualDate': null,
  'lastDate': null,
  'jobs': [],
  'subcontracts': [],
  'parts': [],
  'files': [],
  // estra fields
  'model': '',
  'open': false,
  'processDate': null,
  'openRepairDate': null,
  'endRepairDate': null,
  'evidenceFlag': false,
  'campaignFlag': false,
  'batteryCodeP11': '',
  'batteryCodeP12': '',
  'batteryCodeP21': '',
  'batteryCodeP22': '',
  'diagnosisCodeP1': '',
  'diagnosisCodeP2': '',
  'diagnosisCodeP3': '',
  'diagnosisCodeP4': '',
  'diagnosisCodeP5': '',
  'tsbNo': '',
  'operationType': null,
  'campaignId': 0,
  'errorId': null,
};

class WarrantyAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      'disabledBtns': false,
      'edit': true,
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.WarrantyAdminForm, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    this.props.fetchWarrantyAdminStatus();
    this.props.fetchConditionListWarrantyAdmin();
    this.props.fetchCauseListWarrantyAdmin();
    this.props.fetchRepairListWarrantyAdmin();
    const {code, numTwcDealer, dealerUpdateId} = this.props;
    if (code && numTwcDealer && dealerUpdateId) {
      this.props.getWarrantyAdminByCode(code, numTwcDealer, dealerUpdateId);
      this.setState({
        'disabledBtns': !hasAccessPermission(this.props.permissions, resources.WarrantyAdminForm, scopes.See),
        'title': 'Editar',
        'edit': true,
        'code': code,
        'dealerEdit': dealerUpdateId,
        'getFirstTime': true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {edit, getFirstTime} = this.state;
    const {warranty, loading, updatedWarrantyResponse, updateWarrantyChecking} = this.props;
    if (!isEmpty(this.props.warranty) && edit && (getFirstTime || (prevProps.loading !== loading))) {
      const datesFromWarranty = parseDatesFromProcessedWarranty(warranty);
      const chassis = warranty.chassis;
      const campaignFlag = warranty.campaignFlag;

      this.props.getWarrantyAdminChassis(chassis, campaignFlag);
      this.props.fetchCampaignList({chassis, 'status': 'A'});
      this.setState({
        ...warranty,
        ...datesFromWarranty,
        'getFirstTime': false,
        'operationType': !warranty.operationType && campaignFlag ? 5 : warranty.operationType,
      });
    } else if (updatedWarrantyResponse && prevProps.updateWarrantyChecking !== updateWarrantyChecking) {
      this.setState({
        ...this.state,
        ...updatedWarrantyResponse,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearCampaignsList();
  }

  handleChangeType = (field, value) => {
    this.setState({
      [field]: value,
    });
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
      'model': field === 'chassis' ? '' : this.state.model,
      'invalidKm': field === 'km' ? true : this.state.invalidKm,
    }, () => {
      this.handleCalTwcTotal(field);
    });
  }

  handleCalTwcTotal = (field) => {
    if (field === 'jobs' || field === 'subcontracts' || field === 'parts') {
      const {parts, jobs, subcontracts} = this.state;
      const totalJobs = getTotalColumn(jobs, 'total');
      const totalSubcontracts = getTotalColumn(subcontracts, 'total');
      const totalParts = getTotalColumnPart(parts, 'price', 'quantity').toFixed(2);
      const total = parseFloat(totalJobs) + parseFloat(totalSubcontracts) + parseFloat(totalParts);
      this.setState({
        'totalTwc': +total.toFixed(2),
      });
    }
  }

  handleSearchPart = (value) => {
    this.setState({
      'principalPart': value,
      'principalPartDescription': '',
    });
  }

  handleKeyDownChassis = (e) => {
    const {chassis, campaignFlag} = this.state;
    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      if (chassis.length >= 10 || chassis.length <= 18) {
        this.props.getWarrantyAdminChassis(chassis, campaignFlag);
        this.props.fetchCampaignList({chassis, 'status': 'A'});
      } else {
        this.props.addMessageBoxError('Chasis inválido para la busqueda');
      }
    }
  }

  handleEvent = (e, icon, field) => {
    const value = (e.target && e.target.value) || '';
    if (icon === 'add' && e.key === 'Enter') {
      switch (field) {
        case 'condition':
          this.setState({'conditionEn': value});
          this.props.addConditionWarrantyAdmin(value);
          break;
        case 'cause':
          this.setState({'causeEn': value});
          this.props.addCauseWarrantyAdmin(value);
          break;
        case 'repair':
          this.setState({'repairEn': value});
          this.props.addRepairWarrantyAdmin(value);
          break;
        default:
          break;
      }
    }
  }

  // eslint-disable-next-line max-statements
  handleSubmit = (event) => {
    this.setState({'open': false});

    const {salesDate, repairDate, previousDate, createDate, endDate,
      processDate, openRepairDate, endRepairDate, edit, code, dealerEdit} = this.state;
    const parseSalesDate = convertDateToSpecificFormat(salesDate, reverseShortDate);
    const parseRepairDate = convertDateToSpecificFormat(repairDate, reverseShortDate);
    const parsePreviousDate = convertDateToSpecificFormat(previousDate, reverseShortDate);
    const parseCreateDate = convertDateToSpecificFormat(createDate, reverseShortDate);
    const parseProcessDate = convertDateToSpecificFormat(processDate, reverseShortDate);
    const parseOpenRepairDate = convertDateToSpecificFormat(openRepairDate, reverseShortDate);
    const parseEndRepairDate = convertDateToSpecificFormat(endRepairDate, reverseShortDate);
    const parseEndDate = convertDateToSpecificFormat(endDate, reverseShortDate);

    const data = {
      'dealerId': this.props.dealerId,
      ...this.state,
      'createDate': parseCreateDate,
      'endDate': parseEndDate,
      'salesDate': parseSalesDate,
      'processDate': parseProcessDate,
      'openRepairDate': parseOpenRepairDate,
      'endRepairDate': parseEndRepairDate,
      'repairDate': parseRepairDate,
      'previousDate': parsePreviousDate,
    };

    const {error, message} = validateErrorsWarranty(data);
    if (error) {
      this.props.addMessageBoxError(message);
    } else {
      if (edit) {
        const params = {
          'code': code,
          'dealerId': dealerEdit,
        };
        this.props.updateWarrantyAdmin(data, params);
      }
    }

    event.preventDefault();
  }

  render() {
    const {loading, warrantyStatus, conditionList, updateWarrantyLoading,
      loadingCampaign, vehicle} = this.props;
    const {disabledBtns} = this.state;
    const isLoading = loading || updateWarrantyLoading;
    if (isLoading) {
      return <Loader />;
    }

    return (
      <div className="warranty-container">
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Administrador de Garantías</h2>
              <div className='title-bar-actions'>
                <Button
                  disabled={disabledBtns || loadingCampaign || !vehicle?.chassis}
                  onClick={(e) => this.handleSubmit(e, 'N')}
                  color="green">
                  GUARDAR
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className="">
          <WarrantyAdminForm
            {...this.state}
            handleEvent = {this.handleEvent}
            handleKeyDownChassis = {this.handleKeyDownChassis}
            handleSearchPart = {this.handleSearchPart}
            handleChange = {this.handleChange}
            handleChangeType = {this.handleChangeType}
            handleSelectTypeTwc = {this.handleChangeType}
            warrantyStatus = {warrantyStatus}
            conditionList = {conditionList}
            loading = {loading}
            disabledBtns = {disabledBtns}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {loading, loadingStatus, loadingCause, loadingCondition, loadingRepair} = state.warrantyAdmin;
  const loadingWarranty = loading || loadingStatus || loadingCause || loadingCondition || loadingRepair;
  return {
    'code': ownProps.params && ownProps.params.code,
    'numTwcDealer': ownProps.params && ownProps.params.numTwcDealer,
    'dealerUpdateId': ownProps.params && ownProps.params.dealerId,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'goBack': ownProps.history.goBack,
    'dealerId': state.session.dealerId,
    'warranty': state.warrantyAdmin.warranty,
    'warrantyStatus': state.warrantyAdmin.warrantyStatus,
    'conditionList': state.warrantyAdmin.conditionList,
    'loading': loadingWarranty,
    'updatedWarrantyResponse': state.updateWarrantyAdmin.warranty,
    'updateWarrantyLoading': state.updateWarrantyAdmin.loading,
    'updateWarrantyChecking': state.updateWarrantyAdmin.checking,
    'part': state.warrantiesAdminCategories.part,
    'vehicle': state.warrantyAdminVehicle.vehicle,
  };
};

const {
  withRouter,
  getWarrantyAdminByCode,
  addMessageBoxError,
  fetchWarrantyAdminStatus,
  updateWarrantyAdmin,
  getWarrantyAdminChassis,
  addConditionWarrantyAdmin,
  addCauseWarrantyAdmin,
  addRepairWarrantyAdmin,
  fetchConditionListWarrantyAdmin,
  fetchCauseListWarrantyAdmin,
  fetchRepairListWarrantyAdmin,
  clearCampaignsList,
  fetchCampaignList,
} = Actions;

const mapDispatchToProps = {
  getWarrantyAdminByCode,
  addMessageBoxError,
  addConditionWarrantyAdmin,
  addCauseWarrantyAdmin,
  addRepairWarrantyAdmin,
  updateWarrantyAdmin,
  fetchWarrantyAdminStatus,
  getWarrantyAdminChassis,
  fetchConditionListWarrantyAdmin,
  fetchCauseListWarrantyAdmin,
  fetchRepairListWarrantyAdmin,
  clearCampaignsList,
  fetchCampaignList,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WarrantyAdmin));
